import projection from '../generated/pwg501f1.json';
import { AcceptanceManifest } from '../types';

/** Generated by scripts/build-acceptance-projections.js from the canonical Contract. */
export const pwg501f1AcceptanceManifest = projection as AcceptanceManifest;
